import { z } from "zod";
import { zId } from "./common.js";

export const AUDIT_ACTIONS = [
  "auth.login",
  "auth.login_failed",
  "auth.logout",
  "auth.totp_enabled",
  "auth.passkey_registered",
  "auth.session_revoked",
  "auth.password_reset_requested",
  "auth.password_reset",
  "auth.password_changed",
  "user.invited",
  "user.role_changed",
  "user.suspended",
  "user.reactivated",
  /** CT-RM-33: SCIM provisioning */
  "user.provisioned",
  "user.updated",
  "scim.token_created",
  "scim.token_revoked",
  "role.created",
  "role.updated",
  "role.deleted",
  "org.updated",
  "record.created",
  "record.updated",
  "record.deleted",
  "record.viewed_sensitive",
  "constituent.merged",
  "gift.created",
  "gift.updated",
  "gift.deleted",
  "gift.voided",
  "gift.refunded",
  "batch.created",
  "batch.updated",
  "batch.gift_removed",
  "batch.committed",
  "batch.reversed",
  "receipt.issued",
  "receipt.reissued",
  "export.run",
  "import.run",
  "import.rolled_back",
  "import.duplicates_resolved",
  "import.template_created",
  "import.template_updated",
  "import.template_renamed",
  "import.template_deleted",
  "email.sent",
  "email.queued",
  "segment.exported",
  "ai.tool_call",
  "app.installed",
  "app.uninstalled",
  "oauth.app_created",
  "oauth.app_updated",
  "oauth.app_secret_rotated",
  "oauth.app_deleted",
  "oauth.authorized",
  "oauth.token_issued",
  "oauth.token_revoked",
  "oauth.grant_revoked",
  "oauth.token_reuse_detected",
  "app_card.registered",
  "app_card.updated",
  "app_card.deleted",
  "app_card.enabled",
  "app_card.disabled",
  "app_card.secret_rotated",
  "timeline_event.created",
  "timeline_event.updated",
  "timeline_event.deleted",
  "document.accessed",
  "settings.changed",
  /** CT-RM-35: two-way data sync connections */
  "sync.connection_created",
  "sync.connection_updated",
  "sync.connection_deleted",
  "sync.paused",
  "sync.resumed",
  "sync.run",
  "sync.retry_requested",
  "sync.test_remote_edited",
  /** CT-RM-34: custom objects */
  "custom_object.type_created",
  "custom_object.type_updated",
  "custom_object.type_deleted",
  "custom_object.field_created",
  "custom_object.field_updated",
  "custom_object.field_deleted",
  "custom_object.record_created",
  "custom_object.record_updated",
  "custom_object.record_deleted",
  "custom_object.associated",
  "custom_object.dissociated",
] as const;
export const zAuditAction = z.enum(AUDIT_ACTIONS);
export type AuditAction = z.infer<typeof zAuditAction>;

export const zAuditEntry = z.object({
  id: zId,
  action: zAuditAction,
  actorId: zId.nullable(),
  actorEmail: z.string().nullable(),
  targetTable: z.string().nullable(),
  targetId: z.string().nullable(),
  summary: z.string(),
  metadata: z.record(z.unknown()).default({}),
  ip: z.string().nullable(),
  createdAt: z.string(),
});
export type AuditEntry = z.infer<typeof zAuditEntry>;

export const zAuditQuery = z.object({
  action: zAuditAction.optional(),
  actorId: zId.optional(),
  targetId: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(200).default(50),
});
